export default __webpack_public_path__ + "static/nmn-award-2022-caea324355164195acbcfaef586751d2.svg";